"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _BranchConfig = _interopRequireDefault(require("./BranchConfig.js"));
var _formulaMetrics = _interopRequireDefault(require("./formulaMetrics.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var BranchedCompletionConfig = function BranchedCompletionConfig(_ref) {
  var deploymentId = _ref.deploymentId,
    fields = _ref.fields,
    submitFailed = _ref.submitFailed;
  var branchedCompletionConfig = fields.branchedCompletionConfig;
  var _useState = (0, _react.useState)((0, _get2["default"])(branchedCompletionConfig, 'value.branches', [])),
    _useState2 = _slicedToArray(_useState, 2),
    branches = _useState2[0],
    setBranches = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _get2["default"])(branchedCompletionConfig, 'value.defaultBranch', {})),
    _useState4 = _slicedToArray(_useState3, 2),
    defaultBranch = _useState4[0],
    setDefaultBranch = _useState4[1];
  var _useState5 = (0, _react.useState)(branchedCompletionConfig.error || {}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasLoadedData = _useState8[0],
    setHasLoadedData = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isReorderingBranches = _useState0[0],
    setIsReorderingBranches = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    formulaMetrics = _useState10[0],
    setFormulaMetrics = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    conditionKeyFrequencies = _useState12[0],
    setConditionKeyFrequencies = _useState12[1];
  var _useState13 = (0, _react.useState)((0, _get2["default"])(branchedCompletionConfig, 'value.nextBranchKey') || 1),
    _useState14 = _slicedToArray(_useState13, 2),
    nextBranchKey = _useState14[0],
    setNextBranchKey = _useState14[1];
  var _useState15 = (0, _react.useState)((0, _get2["default"])(branchedCompletionConfig, 'value.nextConditionKey') || 1),
    _useState16 = _slicedToArray(_useState15, 2),
    nextConditionKey = _useState16[0],
    setNextConditionKey = _useState16[1];
  var initialBranchData = {
    conditions: [{
      action: 'message',
      completionMessage: 'You have completed the survey! Thank you for your response!'
    }]
  };

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (!(0, _get2["default"])(branchedCompletionConfig, 'value.defaultBranch')) {
      updateDefaultBranch(_objectSpread(_objectSpread({}, initialBranchData), {}, {
        key: nextBranchKey
      }));
      setNextBranchKey(nextBranchKey + 1);
    }
  }, []);
  (0, _react.useEffect)(function () {
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, receivedKeyFrequencies;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _formulaMetrics["default"],
                variables: {
                  deploymentId: deploymentId || 0
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              result = _context.v;
              setFormulaMetrics((0, _get2["default"])(result, "data.metrics.variableList", []));
              receivedKeyFrequencies = (0, _get2["default"])(result, "data.flows.deployment.assignmentProgressSummary.frequency");
              setConditionKeyFrequencies(receivedKeyFrequencies || []);
              setHasLoadedData(true);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _loadData.apply(this, arguments);
    }
    if (!hasLoadedData) {
      loadData();
    }
  }, [branches]);
  (0, _react.useEffect)(function () {
    if (branchedCompletionConfig.error && submitFailed) {
      setErrors(branchedCompletionConfig.error);
    } else {
      setErrors({});
    }
  }, [branchedCompletionConfig.error, submitFailed]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function addBranch() {
    updateBranches([].concat(_toConsumableArray(branches), [_objectSpread(_objectSpread({}, initialBranchData), {}, {
      key: nextBranchKey
    })]));
    setNextBranchKey(nextBranchKey + 1);
  }
  function deleteBranch(index) {
    return function () {
      (0, _cccisdConfirm["default"])({
        message: 'Delete Branching Rule',
        description: 'Are you sure you want to delete this branching rule?'
      }).then(function () {
        // tinymce was re-using the same instance from the deleted
        // BranchConfig component, so we must force it to re-initialize
        // by unmounting, then remounting a short time later.
        setIsReorderingBranches(true);
        updateBranches(branches.filter(function (_, i) {
          return i !== index;
        }));
        setTimeout(function () {
          return setIsReorderingBranches(false);
        }, 25);
      });
    };
  }

  /*
   * What once was index n should now be index n + 1
   */
  function moveBranchDown(index) {
    if (branches.length < 2 || index === branches.length - 1) {
      return;
    }
    setIsReorderingBranches(true);
    var updatedBranches = [];
    branches.forEach(function (b, i) {
      if (i !== index) {
        updatedBranches.push(b);
      }
      if (i === index + 1) {
        updatedBranches.push(branches[index]);
      }
    });
    updateBranches(updatedBranches);
    setTimeout(function () {
      return setIsReorderingBranches(false);
    }, 25);
  }

  /*
   * What once was index n should now be index n - 1
   */
  function moveBranchUp(index) {
    if (branches.length < 2 || index === 0) {
      return;
    }
    setIsReorderingBranches(true);
    var updatedBranches = [];
    branches.forEach(function (b, i) {
      if (i === index - 1) {
        updatedBranches.push(branches[index]);
      }
      if (i !== index) {
        updatedBranches.push(b);
      }
    });
    updateBranches(updatedBranches);
    setTimeout(function () {
      return setIsReorderingBranches(false);
    }, 25);
  }
  function updateBranch(index) {
    return function (updatedBranchConfig) {
      var updatedBranches = [];
      branches.forEach(function (b, i) {
        updatedBranches.push(i === index ? updatedBranchConfig : b);
      });
      updateBranches(updatedBranches);
    };
  }
  function updateBranchedCompletionConfig(updatedDefaultBranch, updatedBranches) {
    var previousValue = branchedCompletionConfig.value || {};
    branchedCompletionConfig.onChange(_objectSpread(_objectSpread({}, previousValue), {}, {
      defaultBranch: updatedDefaultBranch,
      branches: updatedBranches,
      nextBranchKey: nextBranchKey,
      nextConditionKey: nextConditionKey
    }));
  }
  function updateBranches(updatedBranches) {
    updateBranchedCompletionConfig(defaultBranch, updatedBranches);
    setBranches(updatedBranches);
  }
  function updateDefaultBranch(updatedDefaultBranch) {
    updateBranchedCompletionConfig(updatedDefaultBranch, branches);
    setDefaultBranch(updatedDefaultBranch);
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var branchEvaluationNote = /*#__PURE__*/_react["default"].createElement("div", {
    className: "card border-info mb-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-header text-bg-info"
  }, "Branch Evaluation Order"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-body"
  }, "Note that branches will be evaluated in the order shown. The first branch to match will be used. If none of the branch conditions are met, the Default Branching Rule is used."));
  var renderAddBranch = /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary mb-3",
    onClick: addBranch,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
    spaceRight: true
  }), "Add branching rule");

  /*
   * Yes, this would better belong in BranchConfig, but doing it in this way
   * means adding only 1 additional param instead of 3.
   */
  function renderMoveBranches(index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].dndArrows
    }, /*#__PURE__*/_react["default"].createElement("a", {
      onClick: function onClick() {
        return moveBranchUp(index);
      },
      className: index === 0 ? _style["default"].disabled : null
    }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
      onClick: function onClick() {
        return moveBranchDown(index);
      },
      className: index === branches.length - 1 ? _style["default"].disabled : null
    }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fieldWrapper
  }, branches.length > 0 && branchEvaluationNote, renderAddBranch, branches.map(function (bConfig, index) {
    return /*#__PURE__*/_react["default"].createElement(_BranchConfig["default"], {
      branchIndex: index,
      config: bConfig,
      conditionKeyFrequencies: conditionKeyFrequencies,
      deleteBranch: deleteBranch(index),
      deploymentId: deploymentId,
      errors: (0, _get2["default"])(errors, "branch.".concat(index)),
      fields: fields,
      formulaMetrics: formulaMetrics,
      isReorderingBranches: isReorderingBranches,
      key: index,
      nextConditionKey: nextConditionKey,
      renderMoveBranches: renderMoveBranches(index),
      setNextConditionKey: setNextConditionKey,
      updateConfig: updateBranch(index)
    });
  }), /*#__PURE__*/_react["default"].createElement(_BranchConfig["default"], {
    branchIndex: "defaultBranch",
    config: defaultBranch,
    conditionKeyFrequencies: conditionKeyFrequencies,
    deploymentId: deploymentId,
    errors: (0, _get2["default"])(errors, 'defaultBranch'),
    fields: fields,
    hideDefaultLabel: branches.length === 0,
    isDefault: true,
    key: "default",
    nextConditionKey: nextConditionKey,
    setNextConditionKey: setNextConditionKey,
    updateConfig: updateDefaultBranch
  }));
};
BranchedCompletionConfig.propTypes = {
  fields: _propTypes["default"].object,
  deploymentId: _propTypes["default"].number,
  submitFailed: _propTypes["default"].bool
};
var _default = exports["default"] = BranchedCompletionConfig;